export default __webpack_public_path__ + "static/media/integration-success.8542f55a.svg";